import {
  flattenMenuPages,
  normalizeMenuHierarchy,
} from "./menuRouteMatcher";
import { getMenuItemCode } from "./menuDisplay";

/**
 * rolematches/menu ağacında Page.Code / url eşleşmesi.
 */
export const menuHasPageCode = (menuPages, pageCode) => {
  if (!pageCode) return false;
  const target = String(pageCode).trim().toLowerCase();
  const tree = Array.isArray(menuPages)
    ? normalizeMenuHierarchy(menuPages)
    : [];
  const flat = flattenMenuPages(tree.length ? tree : menuPages);
  return flat.some((page) => {
    const code = getMenuItemCode(page);
    if (code === target) return true;
    const url = String((page && page.url) || "")
      .trim()
      .replace(/^\/+/, "")
      .toLowerCase();
    const name = String((page && page.name) || "")
      .trim()
      .toLowerCase();
    return (
      url === target ||
      url.endsWith("/" + target) ||
      name === target ||
      name.replace(/\s+/g, "-") === target
    );
  });
};
